<ng-container [ngSwitch]="media.type">
  <span icon *ngSwitchCase="'image'">image</span>
  <span icon *ngSwitchCase="'pdf'">pdf</span>
  <span icon *ngSwitchCase="'video'">play</span>
  <span icon *ngSwitchCase="'audio'">audio</span>
  <span icon *ngSwitchCase="'survey'">poll</span>
  <span icon *ngSwitchCase="'eap'">iap</span>
  <span icon *ngSwitchCase="'link'">link</span>
  <span icon *ngSwitchCase="'folder'">file</span>
  <span icon *ngSwitchCase="'explorer'">file</span>
  <span icon *ngSwitchDefault>file</span>
</ng-container>
